import { useGetImages } from "../../../../hooks/attestations/useGetImages";
import { ImageWithLoading } from "../../../common/components/ImageWithLoading";
import Modal from "../../../common/components/Modal";
import { ShareButtons } from "../../../common/ShareButtons";
import { ViewTransactionButton } from "../Buttons";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ViewAttestationModal(_ref) {
  let {
    isOpen,
    onClose,
    impactImageCid,
    transactionUrl = "",
    attestationLink
  } = _ref;
  const {
    data: image,
    isLoading: imagesIsLoading,
    isFetching
  } = useGetImages(impactImageCid ? [impactImageCid] : [], !!impactImageCid);
  const isLoading = imagesIsLoading || !image || !impactImageCid || isFetching;
  const imageSrc = image === null || image === void 0 ? void 0 : image[0];
  const title = "Your donation impact";
  return /*#__PURE__*/_jsx(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col items-center gap-6 mx-auto w-full h-full overflow-x-auto max-w-full md:w-[725px]",
      children: [/*#__PURE__*/_jsx("h2", {
        className: "text-black text-3xl sm:text-4xl md:text-5xl/[52px] text-center font-medium font-sans  text-[clamp(1.5rem, 2vw + 1rem, 2rem)]",
        children: title
      }), /*#__PURE__*/_jsx(ViewTransactionButton, {
        disabled: !transactionUrl,
        onClick: () => window.open(transactionUrl, "_blank")
      }), /*#__PURE__*/_jsx(ImageWithLoading, {
        sizeClass: `max-w-[700px] relative`,
        src: imageSrc,
        isLoading: isLoading
      }), /*#__PURE__*/_jsx(ShareButtons, {
        attestationLink: attestationLink
      })]
    })
  });
}